import { Component, OnInit } from '@angular/core';
import { CursoService } from 'src/app/servicios/curso.service';
import { cursoI } from '../../models/curso.interface';

@Component({
  selector: 'app-modal-video',
  templateUrl: './modal-video.component.html',
  styleUrls: ['./modal-video.component.scss']
})
export class ModalVideoComponent implements OnInit {

  public video:any;
  public cursos:any;
  public cursoSelected:cursoI;
  public validador:boolean=false;
  
  //cambiando a links de youtube
  public linkASubir:any;


  constructor(private cursoSvc:CursoService) { }

  ngOnInit(): void {
    
    this.cursoSvc.getAllCursos().subscribe(res=>
      {
        this.cursos = res;
        console.log(this.cursos)
      })
  }

  // handleArchivo(event:any)
  // {
  //   this.video = event.target.files[0];

  // }


  subir()
  {
    if(this.linkASubir != null || this.linkASubir != undefined || this.linkASubir != "")
    {

      this.cursoSelected.videos.push(this.linkASubir)
       console.log(this.cursoSelected);
       this.cursoSvc.editCursoById(this.cursoSelected);
       this.validador = true;
      this.linkASubir = "";
    }
   
    
    //this.cursoSvc.subirVideos(this.cursoSelected, this.video);
    //this.validador = true;
  }
}
